/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import { TransparentColorPicker } from '../../../../../../../../ui-kit';
import Actions from './Actions';
import InputBlock from './InputBlock';
import Uploader from '../../../../../../common/components/Uploader';
import RecipientBlock from './RecipientBlock';
import { dataAdapter } from '../../../../../contexts/dataAdapter';
import { OptionsMainBlock, RelativeBlock } from '../../Blocks/components/common/StyledEditables';





















const OptionsBlock = (props) => {
  const {
    options,
    handlePickerColorChange,
    isRecipientNameVisible = false,
    addRecipientName,
    colorPickerOptions,
    isTextEditVisible,
    isLinkEditVisible,
    isMailEditVisible,
    inputData,
    handleInputChanges,
    centerAlign = false,
    isRowOptions = false,
    showFileUploader,
    acceptedFormats = [],
    onFileChange,
    filePickerRefCallBack,
    showTransparentButton = false
  } = props;

  const {
    organisationId,
    addFilesToQueue,
    updateAsset
  } = useContext(dataAdapter);

  return (
    <OptionsMainBlock centerAlign={centerAlign} isRowOptions={isRowOptions}>
      <RelativeBlock>
        <Actions options={options} />
        {
        colorPickerOptions && colorPickerOptions.map((colorPickerDetails) =>
        colorPickerDetails.visible &&
        <div style={colorPickerDetails.style} onClick={(e) => e.stopPropagation()}>
                <TransparentColorPicker
            initialValue={{ hex: colorPickerDetails.initialValue }}
            withHash
            transparentButton={showTransparentButton}
            onSaveColor={handlePickerColorChange} />

              </div>

        )}


        {isRecipientNameVisible &&
        <RecipientBlock addRecipientName={addRecipientName} />}

        {
        (isTextEditVisible || isLinkEditVisible || isMailEditVisible) &&
        <InputBlock inputData={inputData} handleInputChanges={handleInputChanges} />}


        {
        showFileUploader &&
        <div onClick={(e) => e.stopPropagation()}>
              <Uploader
            addFilesToQueue={addFilesToQueue}
            accepts={acceptedFormats}
            onChange={onFileChange}
            organisationId={organisationId}
            filePickerRefCallBack={filePickerRefCallBack}
            updateAsset={updateAsset} />

            </div>}


      </RelativeBlock>
    </OptionsMainBlock>);

};

export default OptionsBlock;